export const AX_CONSTANTS_ID = 'ax_constants';

export const CACHE_KEYS = {
  ACCOUNT_NUMBER: 'Account Number',
  NEWSPAPER_ABBREVIATION: 'Newspaper Abbreviation',
  PUBLICATION_CODE: 'Publication Code'
} as const;
